import { useNavigate } from '@tanstack/react-router';
import { useEffect, type ReactNode } from 'react';

import {
  SESSION_TERMINATED_EVENT,
  isSessionTerminatedCode,
  type SessionTerminatedEventDetail,
} from '../api/client.ts';

// Listens for the api-client's session-terminated event and routes the
// user to the /logged-out splash, carrying the failure code so the splash
// can tell apart an un-onboarded user (no account / not yet linked — show
// "finish in the bot") from a blocked account (show "sign in again").
// Separate from SessionExpiredOverlay (which handles 401 + AUTH_STALE)
// because the recovery path differs: expired init-data lets a user reopen
// the WebApp and re-mint a fresh session; a session that never opened sends
// them back through the bot, which the splash explains. Headless component —
// renders nothing.
export const SessionTerminatedRedirect = (): ReactNode => {
  const navigate = useNavigate();
  useEffect(() => {
    const onTerminated = (event: Event): void => {
      const code = (event as CustomEvent<SessionTerminatedEventDetail>).detail?.code;
      void navigate({
        to: '/logged-out',
        search: isSessionTerminatedCode(code) ? { reason: code } : {},
      });
    };
    window.addEventListener(SESSION_TERMINATED_EVENT, onTerminated);
    return (): void => {
      window.removeEventListener(SESSION_TERMINATED_EVENT, onTerminated);
    };
  }, [navigate]);
  return null;
};
